import { MixpanelService } from './mixpanel.service';
export class ApplicationProgressService {
  private _substepCount: number = 0;
  // used to track which sub-step the user is currently in,
  // (eg. "getStarted" vs. "setupAccount" in /register.
  // TODO: not currently initialized on the first sub-step,
  // only updated on continue/back/skip.
  // *** Should rehydrate _activeSubStep when rehydrating the application
  // to guard against page refresh side-effects & first-step scenarios.

  private _activeSubStep: string = '';

  constructor(public mixpanelService: MixpanelService) {}

  public get activeSubStep(): string {
    return this._activeSubStep;
  }

  public set step(step) {
    this._activeSubStep = step;
  }

  public get substepCount(): number {
    return this._substepCount;
  }

  // Call this each time a step forwards is taken within the current wizard, so incremental progress can be
  // displayed in the nav bar driven by this component.
  public substepForward(stepName: string) {
    this._substepCount++;
    this._activeSubStep = stepName;
  }

  // Call this each time a step backwards is taken within the current wizard, so incremental progress can be
  // displayed in the nav bar driven by this component.
  public substepBack(stepName: string) {
    this._substepCount--;
    this._activeSubStep = stepName;
  }

  // Call this when transitioning wizards or otherwise doing things which call for resetting substep count.
  public substepReset() {
    this._substepCount = 0;
  }

  public trackError(product: string, errorCode?: number, h1?: string, response?: any) {
    let requestTraceId;

    // Parse response and replace response/errorCode if values exist
    if (response.status) {
      errorCode = response.status;
    }

    if (response._body) {
      let responseObj = JSON.parse(response._body);
      response = responseObj.errors[0].errorDescription;
      requestTraceId = responseObj.meta.requestTraceId;
    }

    this.mixpanelService.trackError(product, errorCode, h1, response, requestTraceId);
  }
}
